import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                input: 'change'
            }
        }
    }

    init() {
        this.data = JSON.parse(this.el.dataset.info)
        this.url = window.location.href;

        emitter.on('carnetContent', this.update.bind(this));

        this.el.addEventListener('change', this.change.bind(this));
    }

    change(e) {
        if (this.el.checked) {
            emitter.emit('addToCarnet', this.data)
        } else {
            emitter.emit('removeFromCarnet', this.data)
        }
    }

    update(posts) {
        let found = false;
        posts.forEach(post => {
            if (post.id === this.data.id && post.date == this.data.date && post.heure == this.data.heure) {
                this.el.checked = found = true
            }
        })
        if (!found) {
            this.el.checked = false
        }
    }

    destroy() {
        this.el.removeEventListener('change', this.change);
        emitter.off('carnetContent', this.update);
    }
}